import { useCallback, useContext, useMemo } from "react";
import { DrawingContext } from "../../../components/drawing-tool/DrawingTool";
import CultivarForm from "../../cultivation/cultivar/CultivarForm";
import { UpdateDrawingNodeOptions } from "../../cultivation/cultivar/types/cultivarForm.types";

export const CultivarBase = ({ modalData }: { modalData: any }) => {
  const { farmGateId, ingredientId, supplierId, nodeItem } = modalData;
  const {
    chartEdges,
    chartNodes,
    setNodeItem,
    setChartNodes,
    saveDrawing,
    ownerId,
    sourceId,
    lockStatus
  } = useContext(DrawingContext);

  const farmGateParentId = nodeItem?.parentNode;

  const farmGateParentNode = useMemo(
    () => chartNodes.find(node => node.id === farmGateParentId),
    [chartNodes, farmGateParentId]
  );

  const buildUpdatedFarmGateNode = useCallback(
    (currentNode: any, farmGateName?: string) => ({
      ...farmGateParentNode,
      data: {
        ...farmGateParentNode?.data,
        ...(farmGateName && { label: `Farm Gate (${farmGateName})` }),
        reference: {
          ...currentNode.data.reference
        }
      }
    }),
    [farmGateParentNode]
  );

  const updateDrawingNode = useCallback(
    (updatedNode: any, farmGateName?: string, options?: UpdateDrawingNodeOptions) => {
      const updatedFarmGateNode = buildUpdatedFarmGateNode(updatedNode, farmGateName);
      const updatedChartNodes = chartNodes.map(node => {
        if (node.id === nodeItem?.id) return updatedNode;
        if (node.id === farmGateParentId) return updatedFarmGateNode;
        return node;
      });

      setChartNodes(updatedChartNodes);
      setNodeItem(options?.closeModal ? null : updatedNode);
      saveDrawing(chartEdges, updatedChartNodes);
    },
    [
      buildUpdatedFarmGateNode,
      chartEdges,
      chartNodes,
      farmGateParentId,
      nodeItem?.id,
      saveDrawing,
      setChartNodes,
      setNodeItem
    ]
  );

  return (
    <CultivarForm
      supplierId={supplierId}
      ingredientId={ingredientId}
      farmGateId={farmGateId}
      nodeItem={nodeItem}
      ownerId={ownerId}
      sourceId={sourceId}
      lockStatus={lockStatus}
      updateDrawingNode={updateDrawingNode}
      setNodeItem={setNodeItem}
    />
  );
};
